import { bpeConfig } from '@enterprise/common';
import {
  createLdProvider,
  type LdProviderProps,
  useUserIdentification
} from 'integrations/launchDarkly/impl/createLDProvider';
import React, { FC } from 'react';

const localDevDarklyId = '61dc58887be8a515a6c1c85b';

const enableDarkly = !!bpeConfig.integrations.launchDarklyClientId || process.env.NODE_ENV !== 'production';
const isLocalDev = process.env.NODE_ENV === 'development';

const LD = createLdProvider({
  displayName: 'OcDarklyProvider',
  clientSideID: bpeConfig.integrations.launchDarklyClientId || (isLocalDev ? localDevDarklyId : undefined),
  enabled: enableDarkly
});

export const OcDarklyProvider: FC<LdProviderProps & Required<React.PropsWithChildren>> = ({
  children,
  ...identity
}) => {
  useUserIdentification(LD, identity);

  return <LD.Provider>{children}</LD.Provider>;
};
